import React from 'react';
import ButtonContained from '@ntuctech/devex-tangram/Button/ButtonContained';
import SvgTick from '@ntuctech/devex-tangram/Icon/SvgTick';
import Modal from '@ntuctech/devex-tangram/Modal';
import ModalActions from '@ntuctech/devex-tangram/ModalActions';
import ModalContent from '@ntuctech/devex-tangram/ModalContent';
import Typography from '@ntuctech/devex-tangram/Typography';
import styled from 'styled-components';

const ApplyCardBenefitModalSc = styled(Modal)`
  border-radius: 0.25rem;
  padding: 2.5rem 3.5rem;
  width: 30rem;

  .benefit-title {
    margin-bottom: 1rem;
  }
  @media (max-width: 767px) {
    padding: 2rem;
    width: 21.4375rem;
  }
`;

const Illustration = styled.div`
  margin: auto;
  margin-bottom: 2rem;
  background-image: url(${(props) => props.displayPic});
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
  display: block;
  width: 17.5rem;
  height: 11.875rem;

  @media (max-width: 767px) {
    margin-bottom: 1.5rem;
  }
`;

const BenefitRowSc = styled.div`
  display: flex;
  align-items: start;

  svg {
    flex: 0 0 1.5rem;
  }

  .benefit-text {
    margin-left: 0.5rem;
  }
`;

const ModalActionsSc = styled(ModalActions)`
  margin-top: 2rem;

  .cancel-button {
    margin-right: 0.5rem;
  }
`;

const Benefit = (props) => {
  const { benefit } = props;
  return (
    <BenefitRowSc>
      <SvgTick color="#3FC078" />
      <Typography variant="body2" className="benefit-text" data-testid="benefit_text">
        {benefit}
      </Typography>
    </BenefitRowSc>
  );
};

const ApplyCardBenefitList = (props) => {
  const { openBenefitListModal, handleOpenApplyCardBenefitList, handleOpenAddressForm } = props;
  const displayPic =
    'https://media.nedigital.sg/linkpass/files/178c0f08-9f10-45aa-8866-830ab3474381/Link-reward-card.svg';

  const diplayPicTestId = 'display_banner_reward';
  const handleApplyLinkCard = () => {
    handleOpenApplyCardBenefitList(false);
    handleOpenAddressForm(true);
  };

  return (
    <ApplyCardBenefitModalSc open={openBenefitListModal}>
      <Illustration data-testid={diplayPicTestId} displayPic={displayPic} />
      <ModalContent>
        <Typography variant="h3" className="benefit-title" data-testid="apply-card_title">
          Enjoy additionally with a physical Link card
        </Typography>
        <Benefit benefit={`Earn & redeem Linkpoints at over 1,000 partner's outlets`} />
        <Benefit benefit={'No minimum age restrictions'} />
        <Benefit benefit={'No membership or annual fees'} />
      </ModalContent>
      <ModalActionsSc>
        <ButtonContained
          className="cancel-button"
          color="grey"
          onClick={() => handleOpenApplyCardBenefitList(false)}
          data-testid="cancel_button"
        >
          Cancel
        </ButtonContained>
        <ButtonContained data-testid="apply-card_button" onClick={handleApplyLinkCard}>
          Apply now
        </ButtonContained>
      </ModalActionsSc>
    </ApplyCardBenefitModalSc>
  );
};

export default ApplyCardBenefitList;
